import { ChainId, Currency, Native, Token, WNATIVE } from '@nominex/nomiswap-sdk'

export function wrappedCurrency(currency: Currency | undefined, chainId: ChainId | undefined): Token | undefined {
  return chainId && currency?.isNative ? WNATIVE[chainId] : currency?.isToken ? currency : undefined
}

export function unwrappedToken(token: Token): Currency {
  return token.equals(WNATIVE[token.chainId]) ? Native.onChain(token.chainId) : token
}
